import { useEffect, useState } from "react";

export function useDebounceValue(value, delay) {
  var state = useState(value);
  var debouncedValue = state[0];
  var setDebouncedValue = state[1];

  useEffect(function () {
    var timer = setTimeout(function () {
      setDebouncedValue(value);
    }, delay || 0);

    return function () {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return [debouncedValue, setDebouncedValue];
}

export default useDebounceValue;
